export default __webpack_public_path__ + "static/media/step1background.4d8b17c2.svg";